import { createAction, props } from '@ngrx/store';
import { AppUserState } from '../states/app.state';

export const setCurrentUser = createAction(
  '[User] Set Current User',
  props<{ currentUser: AppUserState }>(),
);

export const clearCurrentUser = createAction('[User] Clear Current User');
